import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY


export const getUnidadesKilometraje = (setData)=>
{
    api.get(`${urlApi}/administracion/getUnidadesKilometraje`)
    .then((res)=>
    {   
        setData(res.data)
    })
    .catch((error)=>{
        console.log("error",error);
        
    })
}
export const actualizarKilometraje = (UNIDAD)=>
{
    const params = {
        id:UNIDAD.ID,
        kilometraje:UNIDAD?.KILOMETRAJE,
        km_referencia:UNIDAD?.KM_REFERENCIA,
        km_inicial:UNIDAD?.KM_INICIAL,
        km_wialon:UNIDAD.KM_WIALON,
        user:UNIDAD.USER
    }
    Swal.fire({
        title: 'Cargando...',
        text: 'Obteniendo datos...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }})
    api.patch(`${urlApi}/administracion/getUnidadesKilometraje-update`,params)
    .then((res)=>
    {   
        Swal.close();
    })
    .catch((error)=>{
        console.log("error",error);
        Swal.close();
    })
}
